export default __webpack_public_path__ + "fe16297c82a0b3cade543a334eb048f2.mp3";